var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "ma-5", attrs: { flat: "", loading: _vm.loading } },
    [
      _c("v-card-text", { staticClass: "pa-0" }, [
        _c(
          "div",
          { staticClass: "panel-content px-4 py-4" },
          [
            _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c("div", { staticClass: "d-flex align-center mb-2" }, [
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.$t("current-organization"))),
                  ]),
                ]),
                !_vm.currentOrgAgents.length && !_vm.loading
                  ? _c(
                      "v-alert",
                      { attrs: { type: "info", outlined: "", dense: "" } },
                      [_vm._v(" " + _vm._s(_vm.$t("no-current-agent")) + " ")]
                    )
                  : _vm.currentOrgAgents.length
                  ? _c(
                      "v-list",
                      { staticClass: "pa-0" },
                      _vm._l(_vm.currentOrgAgents, function (currentOrgAgent) {
                        return _c(
                          "v-list-item",
                          {
                            key: currentOrgAgent.id,
                            staticClass: "agent-item current-org-agent mb-2",
                          },
                          [
                            _c(
                              "v-list-item-content",
                              [
                                _c(
                                  "v-list-item-title",
                                  { staticClass: "d-flex align-center" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "font-weight-medium mr-2",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              currentOrgAgent?.organizationName[
                                                "fr-FR"
                                              ]
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-chip",
                                      {
                                        staticClass: "mr-2",
                                        attrs: { "x-small": "", color: "info" },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("current")) + " "
                                        ),
                                      ]
                                    ),
                                    _c("v-spacer"),
                                    _c(
                                      "v-menu",
                                      {
                                        attrs: { "offset-y": "", left: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            icon: "",
                                                            "x-small": "",
                                                          },
                                                        },
                                                        "v-btn",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { small: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-dots-vertical"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c(
                                          "v-list",
                                          { attrs: { dense: "" } },
                                          [
                                            _c(
                                              "v-list-item",
                                              {
                                                attrs: {
                                                  disabled:
                                                    _vm.loading ||
                                                    _vm.resettingId !== null ||
                                                    _vm.downloadingInstaller ||
                                                    _vm.disablingId !== null,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openDownloadInstallerDialog(
                                                      currentOrgAgent
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-list-item-icon",
                                                  { staticClass: "mr-2" },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "blue",
                                                        },
                                                      },
                                                      [_vm._v("mdi-download")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "download-latest-agent"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item",
                                              {
                                                attrs: {
                                                  disabled:
                                                    _vm.loading ||
                                                    _vm.resettingId !== null ||
                                                    _vm.downloadingInstaller ||
                                                    _vm.disablingId !== null,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.confirmResetLastTransfer(
                                                      currentOrgAgent
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-list-item-icon",
                                                  { staticClass: "mr-2" },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "warning",
                                                        },
                                                      },
                                                      [_vm._v("mdi-history")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("reset")) +
                                                      " lastTransfer"
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                            currentOrgAgent.enabled
                                              ? _c(
                                                  "v-list-item",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.loading ||
                                                        _vm.resettingId !==
                                                          null ||
                                                        _vm.downloadingInstaller ||
                                                        _vm.disablingId !==
                                                          null,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.confirmDisableAgent(
                                                          currentOrgAgent
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-icon",
                                                      { staticClass: "mr-2" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              small: "",
                                                              color: "error",
                                                            },
                                                          },
                                                          [_vm._v("mdi-power")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "disable-agent"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "v-list-item",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.loading ||
                                                        _vm.resettingId !==
                                                          null ||
                                                        _vm.downloadingInstaller ||
                                                        _vm.disablingId !==
                                                          null,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.confirmEnableAgent(
                                                          currentOrgAgent
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-icon",
                                                      { staticClass: "mr-2" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              small: "",
                                                              color: "success",
                                                            },
                                                          },
                                                          [_vm._v("mdi-power")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("enable-agent")
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                            _c("v-divider"),
                                            _c(
                                              "v-list-item",
                                              {
                                                attrs: {
                                                  disabled:
                                                    _vm.loading ||
                                                    _vm.resettingId !== null ||
                                                    _vm.downloadingInstaller ||
                                                    _vm.disablingId !== null,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.confirmRemovePatientAgentIntegration(
                                                      currentOrgAgent
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-list-item-icon",
                                                  { staticClass: "mr-2" },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "error",
                                                        },
                                                      },
                                                      [_vm._v("mdi-delete")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass: "error--text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "remove-patient-agent-integration"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-title",
                                  { staticClass: "d-flex align-center" },
                                  [
                                    _c(
                                      "v-chip",
                                      {
                                        staticClass: "mr-2",
                                        attrs: {
                                          color: currentOrgAgent.enabled
                                            ? "primary"
                                            : "error",
                                          "x-small": "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              currentOrgAgent.enabled
                                                ? _vm.$t("enabled")
                                                : _vm.$t("disabled")
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-chip",
                                      {
                                        staticClass: "mr-2",
                                        attrs: {
                                          color: "secondary",
                                          "x-small": "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              currentOrgAgent.erpLabel ||
                                                currentOrgAgent.erpType
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-subtitle",
                                  { staticClass: "mt-1" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex flex-column" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-caption grey--text",
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("organization-id")
                                                ) + ":"
                                              ),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  currentOrgAgent.organizationId
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-caption grey--text",
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("agent-id")) + ":"
                                              ),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(currentOrgAgent.id) +
                                                " "
                                            ),
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "ml-1 copy-icon",
                                                attrs: { small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.copyToClipboard(
                                                      currentOrgAgent.id
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("mdi-content-copy")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-caption grey--text",
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("last-transfer")
                                                ) + ":"
                                              ),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  currentOrgAgent.lastTransfer
                                                    ? _vm.formatDate(
                                                        currentOrgAgent.lastTransfer
                                                      )
                                                    : _vm.$t("never")
                                                ) +
                                                " "
                                            ),
                                            _vm.isTransferStale(
                                              currentOrgAgent.lastTransfer
                                            )
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "ml-1",
                                                    attrs: {
                                                      small: "",
                                                      color: "warning",
                                                    },
                                                  },
                                                  [_vm._v("mdi-alert")]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        currentOrgAgent.nextTransferAt
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-caption grey--text",
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("next-transfer")
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatDate(
                                                        currentOrgAgent.nextTransferAt
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                                _vm.isNextTransferOverdue(
                                                  currentOrgAgent
                                                )
                                                  ? _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: { bottom: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                                attrs,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-icon",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          staticClass:
                                                                            "ml-1",
                                                                          attrs:
                                                                            {
                                                                              small:
                                                                                "",
                                                                              color:
                                                                                "warning",
                                                                            },
                                                                        },
                                                                        "v-icon",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-alert"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "next-transfer-overdue"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.isNextTransferOverdue(
                                                  currentOrgAgent
                                                )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "d-sr-only",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "next-transfer-overdue"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        currentOrgAgent.lastError
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-caption error--text agent-error",
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "mr-1",
                                                    attrs: {
                                                      small: "",
                                                      color: "error",
                                                    },
                                                  },
                                                  [_vm._v("mdi-alert-circle")]
                                                ),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("last-error")
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      currentOrgAgent.lastError
                                                    ) +
                                                    " "
                                                ),
                                                currentOrgAgent.lastErrorAt
                                                  ? [
                                                      _vm._v(
                                                        " (" +
                                                          _vm._s(
                                                            _vm.formatDate(
                                                              currentOrgAgent.lastErrorAt
                                                            )
                                                          ) +
                                                          ") "
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                        currentOrgAgent.lastConnection
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-caption grey--text",
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("last-connection")
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatDate(
                                                        currentOrgAgent.lastConnection
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        currentOrgAgent.version
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-caption grey--text",
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("version", {
                                                        version:
                                                          currentOrgAgent.version,
                                                      })
                                                    )
                                                  ),
                                                ]),
                                                currentOrgAgent.versionUpdatedAt
                                                  ? [
                                                      _vm._v(
                                                        " (" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "version-updated-at",
                                                              {
                                                                date: _vm.formatDate(
                                                                  currentOrgAgent.versionUpdatedAt
                                                                ),
                                                              }
                                                            )
                                                          ) +
                                                          ") "
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-caption grey--text d-flex align-center",
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("query")) + ":"
                                              ),
                                            ]),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "ml-1",
                                                attrs: {
                                                  icon: "",
                                                  "x-small": "",
                                                  loading:
                                                    _vm.queryLoadingId ===
                                                    currentOrgAgent.id,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.toggleQuery(
                                                      currentOrgAgent
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "primary",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.expandedQueryId ===
                                                            currentOrgAgent.id
                                                            ? "mdi-eye-off"
                                                            : "mdi-eye"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm.expandedQueryId ===
                                            currentOrgAgent.id
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "ml-1 copy-icon",
                                                    attrs: { small: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.copyToClipboard(
                                                          _vm.agentQueries[
                                                            currentOrgAgent.id
                                                          ]?.query || ""
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("mdi-content-copy")]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm.expandedQueryId === currentOrgAgent.id
                                  ? _c(
                                      "div",
                                      { staticClass: "query-section mt-2" },
                                      [
                                        _c(
                                          "pre",
                                          {
                                            staticClass:
                                              "query-content text-caption",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatQuery(
                                                  _vm.agentQueries[
                                                    currentOrgAgent.id
                                                  ]?.query
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("v-divider", { staticClass: "mb-4" }),
            _c(
              "div",
              [
                _c(
                  "div",
                  {
                    staticClass: "d-flex align-center mb-2 other-agents-header",
                    on: { click: _vm.toggleOtherAgents },
                  },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "mr-2", attrs: { small: "" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.showOtherAgents
                                ? "mdi-chevron-down"
                                : "mdi-chevron-right"
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.$t("other-agents"))),
                    ]),
                    _c(
                      "v-chip",
                      {
                        staticClass: "ml-2",
                        attrs: { "x-small": "", color: "grey lighten-2" },
                      },
                      [_vm._v(" " + _vm._s(_vm.otherAgents.length) + " ")]
                    ),
                    _vm.loadingOtherAgents
                      ? _c("v-progress-circular", {
                          staticClass: "ml-2",
                          attrs: { indeterminate: "", size: "16", width: "2" },
                        })
                      : _vm._e(),
                    _c("v-spacer"),
                    _vm.showOtherAgents && _vm.otherAgents.length > 0
                      ? [
                          _c(
                            "span",
                            { staticClass: "text-caption grey--text mr-2" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.filteredOtherAgents.length) +
                                  " / " +
                                  _vm._s(_vm.otherAgents.length) +
                                  " "
                              ),
                            ]
                          ),
                          _vm.showOnlyStale
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    small: "",
                                    close: "",
                                    color: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    "click:close": function ($event) {
                                      _vm.showOnlyStale = false
                                    },
                                  },
                                },
                                [_vm._v(" 7+ " + _vm._s(_vm.$t("days")) + " ")]
                              )
                            : _vm._e(),
                          _vm.showOnlyDisabled
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    small: "",
                                    close: "",
                                    color: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    "click:close": function ($event) {
                                      _vm.showOnlyDisabled = false
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("disabled")) + " ")]
                              )
                            : _vm._e(),
                          _vm._l(_vm.selectedErpTypes, function (erpType) {
                            return _c(
                              "v-chip",
                              {
                                key: erpType,
                                staticClass: "mr-2 text-capitalize",
                                attrs: {
                                  small: "",
                                  close: "",
                                  color: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                  "click:close": function ($event) {
                                    return _vm.toggleErpType(erpType)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(erpType) + " ")]
                            )
                          }),
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "offset-y": "",
                                "close-on-content-click": false,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-badge",
                                          {
                                            attrs: {
                                              value: _vm.activeFilterCount > 0,
                                              content: _vm.activeFilterCount,
                                              color: "primary",
                                              overlap: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      small: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                      },
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-filter"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3714908966
                              ),
                            },
                            [
                              _c(
                                "v-list",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          _vm.showOnlyStale = !_vm.showOnlyStale
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-action",
                                        { staticClass: "mr-2" },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              "hide-details": "",
                                              dense: "",
                                            },
                                            model: {
                                              value: _vm.showOnlyStale,
                                              callback: function ($$v) {
                                                _vm.showOnlyStale = $$v
                                              },
                                              expression: "showOnlyStale",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("filter-stale-transfers")
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          _vm.showOnlyDisabled =
                                            !_vm.showOnlyDisabled
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-action",
                                        { staticClass: "mr-2" },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              "hide-details": "",
                                              dense: "",
                                            },
                                            model: {
                                              value: _vm.showOnlyDisabled,
                                              callback: function ($$v) {
                                                _vm.showOnlyDisabled = $$v
                                              },
                                              expression: "showOnlyDisabled",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          _vm._s(_vm.$t("filter-disabled"))
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c("v-divider", { staticClass: "my-1" }),
                                  _c("v-subheader", [
                                    _vm._v(_vm._s(_vm.$t("erp-type"))),
                                  ]),
                                  _vm._l(_vm.erpTypes, function (erpType) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: erpType,
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleErpType(erpType)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-action",
                                          { staticClass: "mr-2" },
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                "input-value":
                                                  _vm.selectedErpTypes.includes(
                                                    erpType
                                                  ),
                                                "hide-details": "",
                                                dense: "",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "text-capitalize" },
                                          [_vm._v(" " + _vm._s(erpType) + " ")]
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm.showOtherAgents
                  ? [
                      !_vm.filteredOtherAgents.length && !_vm.loadingOtherAgents
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mb-4",
                              attrs: { type: "info", outlined: "", dense: "" },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("no-agents-found")) + " "
                              ),
                            ]
                          )
                        : _c(
                            "v-list",
                            { staticClass: "pa-0" },
                            _vm._l(
                              _vm.filteredOtherAgents,
                              function (agent, index) {
                                return _c(
                                  "div",
                                  { key: `${agent.id}-${index}` },
                                  [
                                    _c(
                                      "v-list-item",
                                      { staticClass: "agent-item mb-2" },
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "d-flex align-center",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-medium mr-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          agent
                                                            ?.organizationName[
                                                            "fr-FR"
                                                          ]
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-spacer"),
                                                _c(
                                                  "v-menu",
                                                  {
                                                    attrs: {
                                                      "offset-y": "",
                                                      left: "",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                            attrs,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "v-btn",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {
                                                                      attrs: {
                                                                        icon: "",
                                                                        "x-small":
                                                                          "",
                                                                      },
                                                                    },
                                                                    "v-btn",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        small:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-dots-vertical"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c(
                                                      "v-list",
                                                      { attrs: { dense: "" } },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                _vm.loading ||
                                                                _vm.resettingId !==
                                                                  null ||
                                                                _vm.disablingId !==
                                                                  null,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.confirmResetLastTransfer(
                                                                  agent
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-icon",
                                                              {
                                                                staticClass:
                                                                  "mr-2",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      small: "",
                                                                      color:
                                                                        "warning",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-history"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-list-item-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "reset"
                                                                    )
                                                                  ) +
                                                                    " lastTransfer"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        agent.enabled
                                                          ? _c(
                                                              "v-list-item",
                                                              {
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.loading ||
                                                                    _vm.resettingId !==
                                                                      null ||
                                                                    _vm.disablingId !==
                                                                      null,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.confirmDisableAgent(
                                                                        agent
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mr-2",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            "",
                                                                          color:
                                                                            "error",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-power"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-list-item-title",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "disable-agent"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _c(
                                                              "v-list-item",
                                                              {
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.loading ||
                                                                    _vm.resettingId !==
                                                                      null ||
                                                                    _vm.disablingId !==
                                                                      null,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.confirmEnableAgent(
                                                                        agent
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mr-2",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            "",
                                                                          color:
                                                                            "success",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-power"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-list-item-title",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "enable-agent"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "d-flex align-center",
                                              },
                                              [
                                                _c(
                                                  "v-chip",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      color: agent.enabled
                                                        ? "primary"
                                                        : "error",
                                                      "x-small": "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          agent.enabled
                                                            ? _vm.$t("enabled")
                                                            : _vm.$t("disabled")
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-chip",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      color: "secondary",
                                                      "x-small": "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          agent.erpLabel ||
                                                            agent.erpType
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "mt-1" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-column",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-caption grey--text",
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "organization-id"
                                                              )
                                                            ) + ":"
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              agent.organizationId
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-caption grey--text",
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("agent-id")
                                                            ) + ":"
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(agent.id) +
                                                            " "
                                                        ),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "ml-1 copy-icon",
                                                            attrs: {
                                                              small: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.copyToClipboard(
                                                                  agent.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-content-copy"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-caption grey--text",
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "last-transfer"
                                                              )
                                                            ) + ":"
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              agent.lastTransfer
                                                                ? _vm.formatDate(
                                                                    agent.lastTransfer
                                                                  )
                                                                : _vm.$t(
                                                                    "never"
                                                                  )
                                                            ) +
                                                            " "
                                                        ),
                                                        _vm.isTransferStale(
                                                          agent.lastTransfer
                                                        )
                                                          ? _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "ml-1",
                                                                attrs: {
                                                                  small: "",
                                                                  color:
                                                                    "warning",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-alert"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                    agent.nextTransferAt
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-caption grey--text",
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "next-transfer"
                                                                  )
                                                                ) + ":"
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.formatDate(
                                                                    agent.nextTransferAt
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                            _vm.isNextTransferOverdue(
                                                              agent
                                                            )
                                                              ? _c(
                                                                  "v-tooltip",
                                                                  {
                                                                    attrs: {
                                                                      bottom:
                                                                        "",
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "activator",
                                                                            fn: function ({
                                                                              on,
                                                                              attrs,
                                                                            }) {
                                                                              return [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  _vm._g(
                                                                                    _vm._b(
                                                                                      {
                                                                                        staticClass:
                                                                                          "ml-1",
                                                                                        attrs:
                                                                                          {
                                                                                            small:
                                                                                              "",
                                                                                            color:
                                                                                              "warning",
                                                                                          },
                                                                                      },
                                                                                      "v-icon",
                                                                                      attrs,
                                                                                      false
                                                                                    ),
                                                                                    on
                                                                                  ),
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-alert"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            },
                                                                          },
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "next-transfer-overdue"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.isNextTransferOverdue(
                                                              agent
                                                            )
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "d-sr-only",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "next-transfer-overdue"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    agent.lastError
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-caption error--text agent-error",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "mr-1",
                                                                attrs: {
                                                                  small: "",
                                                                  color:
                                                                    "error",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-alert-circle"
                                                                ),
                                                              ]
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "last-error"
                                                                  )
                                                                ) + ":"
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  agent.lastError
                                                                ) +
                                                                " "
                                                            ),
                                                            agent.lastErrorAt
                                                              ? [
                                                                  _vm._v(
                                                                    " (" +
                                                                      _vm._s(
                                                                        _vm.formatDate(
                                                                          agent.lastErrorAt
                                                                        )
                                                                      ) +
                                                                      ") "
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        )
                                                      : _vm._e(),
                                                    agent.lastConnection
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-caption grey--text",
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "last-connection"
                                                                  )
                                                                ) + ":"
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.formatDate(
                                                                    agent.lastConnection
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    agent.version
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-caption grey--text",
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "version",
                                                                    {
                                                                      version:
                                                                        agent.version,
                                                                    }
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                            agent.versionUpdatedAt
                                                              ? [
                                                                  _vm._v(
                                                                    " (" +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "version-updated-at",
                                                                          {
                                                                            date: _vm.formatDate(
                                                                              agent.versionUpdatedAt
                                                                            ),
                                                                          }
                                                                        )
                                                                      ) +
                                                                      ") "
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-caption grey--text d-flex align-center",
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("query")
                                                            ) + ":"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            staticClass: "ml-1",
                                                            attrs: {
                                                              icon: "",
                                                              "x-small": "",
                                                              loading:
                                                                _vm.queryLoadingId ===
                                                                agent.id,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.toggleQuery(
                                                                  agent
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                  color:
                                                                    "primary",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.expandedQueryId ===
                                                                        agent.id
                                                                        ? "mdi-eye-off"
                                                                        : "mdi-eye"
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm.expandedQueryId ===
                                                        agent.id
                                                          ? _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "ml-1 copy-icon",
                                                                attrs: {
                                                                  small: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.copyToClipboard(
                                                                        _vm
                                                                          .agentQueries[
                                                                          agent
                                                                            .id
                                                                        ]
                                                                          ?.query ||
                                                                          ""
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-content-copy"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm.expandedQueryId === agent.id
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "query-section mt-2",
                                                  },
                                                  [
                                                    _c(
                                                      "pre",
                                                      {
                                                        staticClass:
                                                          "query-content text-caption",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.formatQuery(
                                                              _vm.agentQueries[
                                                                agent.id
                                                              ]?.query
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-divider", { staticClass: "my-1" }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("confirmation-dialog", {
        ref: "dialogRef",
        attrs: { "content-class": "devops-subdialog" },
      }),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.downloadInstallerDialog,
            callback: function ($$v) {
              _vm.downloadInstallerDialog = $$v
            },
            expression: "downloadInstallerDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("download-latest-agent")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        small: "",
                        disabled: _vm.downloadingInstaller,
                      },
                      on: { click: _vm.closeDownloadInstallerDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c(
                "v-card-text",
                { staticClass: "pb-2" },
                [
                  _c(
                    "v-radio-group",
                    {
                      staticClass: "mt-0",
                      attrs: {
                        disabled: _vm.downloadingInstaller,
                        dense: "",
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.downloadInstallerMode,
                        callback: function ($$v) {
                          _vm.downloadInstallerMode = $$v
                        },
                        expression: "downloadInstallerMode",
                      },
                    },
                    [
                      _c("v-radio", {
                        attrs: {
                          label: _vm.$t("agent-install-new"),
                          value: "new",
                        },
                      }),
                      _c("v-radio", {
                        attrs: {
                          label: _vm.$t("agent-install-repair"),
                          value: "repair",
                          disabled: !_vm.downloadInstallerCanRepair,
                        },
                      }),
                    ],
                    1
                  ),
                  !_vm.downloadInstallerCanRepair
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mt-3 mb-0",
                          attrs: { type: "warning", text: "", dense: "" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("agent-install-repair-unavailable")
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "text-caption grey--text mt-2" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.downloadInstallerMode === "new"
                            ? _vm.$t("agent-install-new-hint")
                            : _vm.$t("agent-install-repair-hint")
                        ) +
                        " "
                    ),
                  ]),
                  _vm.downloadInstallerMode === "new"
                    ? _c("v-checkbox", {
                        staticClass: "mt-4",
                        attrs: {
                          label: _vm.$t("agent-reset-last-transfer"),
                          disabled: _vm.downloadingInstaller,
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.downloadInstallerResetLastTransfer,
                          callback: function ($$v) {
                            _vm.downloadInstallerResetLastTransfer = $$v
                          },
                          expression: "downloadInstallerResetLastTransfer",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-space-between" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: {
                        color: "error",
                        disabled: _vm.downloadingInstaller,
                      },
                      on: { click: _vm.closeDownloadInstallerDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: {
                        color: "primary",
                        loading: _vm.downloadingInstaller,
                      },
                      on: { click: _vm.downloadAgentInstaller },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("continue")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.licenseKeyDialog,
            callback: function ($$v) {
              _vm.licenseKeyDialog = $$v
            },
            expression: "licenseKeyDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("agent-license-key")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.licenseKeyDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c(
                "v-card-text",
                { staticClass: "pb-2" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-4",
                      attrs: { type: "info", text: "", dense: "" },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("agent-license-key-info")) + " "
                      ),
                    ]
                  ),
                  _c("v-text-field", {
                    attrs: {
                      value: _vm.agentLicenseAgentId,
                      label: _vm.$t("agent-id"),
                      outlined: "",
                      dense: "",
                      readonly: "",
                      "append-icon": "mdi-content-copy",
                    },
                    on: {
                      "click:append": function ($event) {
                        return _vm.copyToClipboard(_vm.agentLicenseAgentId)
                      },
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      value: _vm.agentLicenseKey,
                      label: _vm.$t("license-key"),
                      outlined: "",
                      dense: "",
                      readonly: "",
                      "append-icon": "mdi-content-copy",
                    },
                    on: {
                      "click:append": function ($event) {
                        return _vm.copyToClipboard(_vm.agentLicenseKey)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.licenseKeyDialog = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("close")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }